// extracted by mini-css-extract-plugin
export default {"buttonContainer":"batching-failure-modal_buttonContainer__9108c","itemContainer":"batching-failure-modal_itemContainer__24319"};